export const fieldNames = {
    stateId: 'stateId',
    codesAreSaved: 'codesAreSaved',
} as const;
